export const px = (s: string | number) => `${s}px`
